import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateGamePartnerAdd = {
  gamePartnerAdd: { data: null, loading: false, error: null },
};

export const gamePartnerAdd = createAsyncThunk('user/gamePartnerAdd', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/game/partner/add`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGamePartnerAdd = {
  [gamePartnerAdd.pending]: (state) => {
    state.gamePartnerAdd.loading = true;
  },
  [gamePartnerAdd.fulfilled]: (state, action) => {
    state.gamePartnerAdd.loading = false;
    state.gamePartnerAdd.data = action.payload;
    state.gamePartnerAdd.error = null;
  },
  [gamePartnerAdd.rejected]: (state, action) => {
    state.gamePartnerAdd.loading = false;
    state.gamePartnerAdd.error = action.payload;
  },
};
